import { SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function ComplianceReviewHoldNotice() {
  const { t } = useTranslation();

  return (
    <SectionMessage
      type="warning"
      icon="warning"
      sectionTitle={t("Pending compliance review")}
      testID="compliance-review-hold-notice"
    >
      {t(
        "This check is complete. The result is being held as part of a compliance review for this case, and will be released automatically once that review is finished."
      )}
    </SectionMessage>
  );
}
